import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from "react-router-dom";

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import { getCountry } from '../../routes/UserAction';
import { domain, reduceText, timeFormat } from '../../data/dummyData';

import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Carousel.css";

export default function Country() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);

    const search = useLocation().search;
    const id = new URLSearchParams(search).get("id");

    const [countryData, setCountryData] = useState(null);
    const [selectedTask, setSelectedTask] = useState(null);
    const [solutionFile, setSolutionFile] = useState(null);

    useEffect(() => {
        dispatch(getCountry(id))
            .then(response => {
                setCountryData(response.payload.data);
            })
            .catch(console.error);
    }, [id]);

    const handleUploadSolution = (taskId) => {
        setSelectedTask(taskId);
        document.getElementById('uploadModal').style.display = 'block';
    };

    const closeModal = () => {
        setSelectedTask(null);
        setSolutionFile(null);
        document.getElementById('uploadModal').style.display = 'none';
    };

    const handleFileChange = (e) => {
        setSolutionFile(e.target.files[0]);
    };

    const submitSolution = () => {
        if (solutionFile) {
            console.log('Submitting file for task:', selectedTask, solutionFile);
            closeModal();
        }
    };

    const options2 = {
        loop: true,
        margin: 10,
        nav: true, // ✅ Enable navigation arrows
        dots: false, // Hide dots if not needed
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        },
        navText: [
            "<i class='bi bi-arrow-left custom-arrow text-white'></i>",
            "<i class='bi bi-arrow-right custom-arrow text-white'></i>",
        ], // ✅ Custom arrows
    };

    const options3 = {
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        // items: 3,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        }
    };

    return (
        <>
            <Header page={'country'} />

            {/* <!-- About Start --> */}
            <div className="container-fluid about pt-5" style={{zIndex: 1}}>
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                            <div className="about-content h-100">
                                <h4 className="" style={{color: 'gold'}}>{countryData?.country?.name? countryData.country.name: ''}({countryData?.name? countryData.name: ''})</h4>
                                <h1 className="display-4 text-white mb-4">{countryData?.country?.about? countryData.country.about: ''}</h1>
                                <hr/>
                                <p className="mb-4 text-white">{countryData?.about? countryData.about: ''}</p>
                                
                                
                            </div>
                        </div>
                        <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="about-img h-100">
                                <div className="about-img-inner d-flex h-100">
                                    <img src={countryData?.image? domain+countryData.image: "./assets/img/emy.png"} className="img-fluid w-100" style={{objectFit: 'contain'}} alt={countryData?.uuid? countryData.uuid :''}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}

            {/* <!-- Clubs Start --> */}
            <div className="container-fluid blog py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        {/* <h4 className="text-primary">  Our Blogs</h4> */}
                        <h4 className="" style={{color: 'gold'}}> EmyClubs in {countryData?.country?.name? countryData.country.name: ''} </h4>
                        <h1 className="display-4 mb-4">Clubs</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                        </p> */}
                    </div>

                    <OwlCarousel
                        className="blog-carousel owl-carousel"
                        {...options3}
                    >
                    {/* <div className="blog-carousel owl-carousel"> */}
                    {countryData?.country?.schools?.map((school) =>
                        school.clubs?.map((row) => (
                            <div className="blog-item wow fadeInUp" data-wow-delay="0.2s" key={row.id}>
                            <div className="blog-img p-4 pb-0">
                                <a href="#">
                                <img
                                    src={row.image ? domain + row.image : "./assets/img/soft.png"}
                                    className="img-fluid w-100"
                                    alt=""
                                />
                                </a>
                            </div>
                            <div className="blog-content p-4">
                                <div className="blog-comment d-flex justify-content-between py-2 px-3 mb-4">
                                    <div className="small">
                                        <span className="fa fa-users text-primary me-2"></span> {row.members?.length? row.members.length: 0}
                                    </div>
                                    <div className="small">
                                        <span className="fa fa-calendar text-primary me-2"></span> {timeFormat(row.created_at)}
                                    </div>
                                </div>
                                <Link to={row.uuid ? `/club?id=${row.uuid}` : '/'} className="h4 d-inline-block mb-3">
                                {row.name || ''}({row.school?.name? row.school?.name: ''})
                                </Link>
                                <p className="mb-3">{row.about? reduceText(row.about, 200, '...'): ''}</p>
                                <Link to={row.uuid ? `/club?id=${row.uuid}` : '/'} className="btn btn-dark py-2 px-4 ms-2">
                                <span className="me-2">Read More</span> <i className="fa fa-arrow-right"></i>
                                </Link>
                            </div>
                            </div>
                        ))
                    )}
                        
                    {/* </div> */}
                    </OwlCarousel>
                </div>
            </div>
            {/* <!-- Clubs End --> */}

            {/* <!--Schools Start --> */}
            <div className="container-fluid feature">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        <h4 className="" style={{color: 'gold'}}> Schoools</h4>
                        <h1 className="display-4 mb-4">Schools with emyclubs</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam.
                        </p> */}
                    </div>

                    <OwlCarousel
                        className="feature-carousel owl-carousel"
                        {...options2}
                    >
                    {/* <div className="feature-carousel owl-carousel"> */}
                        {countryData?.country?.schools? countryData.country.schools?.map((row) => (
                            <div key={row.id} className="feature-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="feature-img">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100"  alt=""/>
                                </div>
                                <div className="feature-content p-4">
                                    <h4 className="mb-3">{row.name? row.name: ''}</h4>
                                    <p className="mb-4">
                                        {row.about? row.about: ''}
                                    </p>
                                    {/* <Link to={row.uuid? `/country?id=${row.uuid}`:'/'} className="btn btn-primary py-2 px-4"> <span>Register a School</span></Link> */}
                                </div>
                            </div>
                        )) : null}
                        
                    {/* </div> */}
                    </OwlCarousel>
                    <div className="feature-shaps"></div>
                </div>
            </div>
            {/* <!-- Schools End --> */}

            {/* <!-- Team Start --> */}
            <div className="container-fluid blog py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        {/* <h4 className="text-primary">  Our Blogs</h4> */}
                        <h4 className="" style={{color: 'gold'}}> {countryData?.name? countryData?.name : ''} Team </h4>
                        <h1 className="display-4 mb-4">Team Members</h1>
                    </div>

                    <OwlCarousel
                        className="blog-carousel owl-carousel"
                        {...options3}
                    >
                    {/* <div className="blog-carousel owl-carousel"> */}
                    {Array.isArray(countryData?.country?.groups) &&
                        countryData.country.groups.length > 0 &&
                        countryData.country.groups[0].members?.length ? (
                        countryData.country.groups[0].members.map((row, index) => (
                            <div key={index} className="blog-item wow fadeInUp" data-wow-delay="0.2s">
                            <div className="blog-img p-4 pb-0">
                                <a href="#">
                                <img
                                    src={row.image ? domain + row.image : "./assets/img/soft.png"}
                                    className="img-fluid w-100"
                                    alt=""
                                />
                                </a>
                            </div>
                            <div className="blog-content p-4">
                                <div className="blog-comment d-flex justify-content-center py-2 px-3 mb-4">
                                <div className="small text-primary">
                                    <span className="fa fa-calendar text-primary me-2"></span>
                                    {row?.msg || ''}
                                </div>
                                </div>
                                <a href="#" className="h4 d-inline-block mb-3">{row?.name || ''}</a>
                                <p className="mb-3">{row?.about ? reduceText(row.about, 200, '...') : ''}</p>
                                <Link to={row.uuid ? `/chat?id=${row.uuid}&&cat=member` : '/'} className="btn btn-dark py-2 px-4 ms-2">
                                <span className="me-2">Contact</span>
                                <i className="fa fa-arrow-right"></i>
                                </Link>
                            </div>
                            </div>
                        ))
                        ) : null}
                        
                    {/* </div> */}
                    </OwlCarousel>
                </div>
            </div>
            {/* <!-- Team End --> */}

            {/* <!--Branches Start --> */}
            <div className="container-fluid feature">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        <h4 className="" style={{color: 'gold'}}> Branchess</h4>
                        <h1 className="display-4 mb-4">All Registered Branches</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam.
                        </p> */}
                    </div>

                    <OwlCarousel
                        className="feature-carousel owl-carousel"
                        {...options2}
                    >
                    {/* <div className="feature-carousel owl-carousel"> */}
                        {countryData?.country?.branches? countryData.country.branches?.map((row) => (
                            <div key={row.id} className="feature-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="feature-img">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100"  alt=""/>
                                </div>
                                <div className="feature-content p-4">
                                    <h4 className="mb-3">{row.name? row.name: ''}</h4>
                                    <p className="mb-4">
                                        {row.about? row.about: ''}
                                    </p>
                                    <Link to={row.uuid? `/branch?id=${row.uuid}`:'/'} className="btn btn-primary py-2 px-4"> <span>View</span></Link>
                                </div>
                            </div>
                        )) : null}
                        
                    {/* </div> */}
                    </OwlCarousel>
                    <div className="feature-shaps"></div>
                </div>
            </div>
            {/* <!-- Branches End --> */}

            {/* map */}
            <div className="col-12 wow fadeInUp" data-wow-delay="0.2s">
                <div className="h-100 overflow-hidden">
                    <iframe className="w-100" style={{height: '400px'}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd" 
                    loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
            {/* Map End */}

            <Footer />
        </>
    );
}
